import { use, useEffect, useState } from "react";
import { ApproveRejctRequest, RoleResponseModel, UserRequestTable } from "../../_core/_model";
import React from "react";
import { UserRequestRole } from "../Forms/UserRequest/_core/_models";
import { defaultTheme } from "../../styles/themes/defaultTheme";
import { IoMdClose } from "react-icons/io";
import PasswordField from "../Tools/PasswordField.tsx";
import PasswordInput from "../Tools/PasswordInput.tsx";

interface request {
    user: UserRequestTable,
    readOnly: boolean,
    formData: ApproveRejctRequest,
    setFormData: (request: ApproveRejctRequest) => void
}
export function UserRequestDetails({ user, readOnly, formData, setFormData }: request) {
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        let prev = formData;
        if (typeof prev != 'undefined') {
            prev[name] = type === 'checkbox' ? checked : value;
            setFormData({ ...prev });
        }
    };
    return (
        <div>
            <div className="d-flex justify-content-between align-items-center">
                <div className="col-md-12 mb-3">
                    <div className="d-flex flex-row align-items-center gap-2">
                        {
                            user.stagingUserID > 0 ?
                                <>
                                    <label className="form-label fw-bold">User Name:</label>
                                    <label className="form-label">
                                        {user.userName}
                                    </label>
                                </> :
                                <div className="row w-100">
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label fw-bold">User Name:</label>
                                        <input
                                            type="text"
                                            name="userName"
                                            readOnly={readOnly}
                                            value={formData?.userName}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </div>
            <div className="card mb-4 j_req_e_uInfo">
                <div className="card-header" style={{ backgroundColor: defaultTheme.colors.background, color: defaultTheme.colors.text }}>
                    <h4 className="mb-0 fs-5">User Information</h4>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Email:</label>
                            <input
                                type="text"
                                name="email"
                                disabled
                                readOnly={readOnly}
                                value={formData?.email}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>
                        {/* {
                            user.isAdUser != 1 && (
                                readOnly ?
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label fw-bold">Password:</label>
                                        <PasswordInput name="password"
                                            readOnly={readOnly}
                                            value={formData?.password}
                                            onChange={handleChange} />
                                    </div> :
                                    <div className="col-md-12 mb-3">
                                        <PasswordField initValue={formData.password} onChange={(v) => {
                                            let prev = formData;
                                            if (typeof prev != 'undefined') {
                                                prev.password = v;
                                                setFormData({ ...prev });
                                            }
                                        }} />
                                    </div>
                            )
                        } */}

                    </div>
                </div>
            </div>
            {/* <div className="card mb-4">
                <div className="card-header" style={{ backgroundColor: defaultTheme.colors.background, color: defaultTheme.colors.text }}>
                    <h4 className="mb-0 fs-5">General Attributes</h4>
                </div>
                <div className="card-body row">
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-bold">Language Code:</label>
                        <select
                            className="form-select"
                            name="languageCode"
                            disabled={readOnly}
                            value={formData?.languageCode}
                            onChange={handleChange}
                        >
                            <option value="en">English</option>
                            <option value="zh">Chinese (Simplified)</option>
                            <option value="zh-TW">Chinese (Traditional)</option>
                            <option value="es">Spanish</option>
                            <option value="hi">Hindi</option>
                            <option value="ar">Arabic</option>
                            <option value="fr">French</option>
                            <option value="de">German</option>
                            <option value="ja">Japanese</option>
                            <option value="ru">Russian</option>
                            <option value="pt">Portuguese</option>
                            <option value="bn">Bengali</option>
                            <option value="ko">Korean</option>
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-bold">Currency Code:</label>
                        <select
                            className="form-select"
                            value={formData?.currencyCode}
                            disabled={readOnly}
                            name="currencyCode"
                            onChange={handleChange}
                        >
                            <option value="USD">US Dollar (USD)</option>
                            <option value="EUR">Euro (EUR)</option>
                            <option value="JPY">Japanese Yen (JPY)</option>
                            <option value="GBP">British Pound (GBP)</option>
                            <option value="AUD">Australian Dollar (AUD)</option>
                            <option value="CAD">Canadian Dollar (CAD)</option>
                            <option value="CHF">Swiss Franc (CHF)</option>
                            <option value="CNY">Chinese Yuan (CNY)</option>
                            <option value="HKD">Hong Kong Dollar (HKD)</option>
                            <option value="INR">Indian Rupee (INR)</option>
                            <option value="KRW">South Korean Won (KRW)</option>
                            <option value="BRL">Brazilian Real (BRL)</option>
                            <option value="ZAR">South African Rand (ZAR)</option>
                            <option value="SGD">Singapore Dollar (SGD)</option>
                            <option value="MXN">Mexican Peso (MXN)</option>
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-bold">Default Mobile Page:</label>
                        <input
                            type="text"
                            readOnly={readOnly}
                            name="defaultMobilePage"
                            value={formData?.defaultMobilePage}
                            onChange={handleChange}
                            className="form-control"
                        />
                    </div>
                </div>
            </div> */}
        </div>
    )
}

export default UserRequestDetails;